import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import find from 'lodash/find';
import summaryTitle from 'lib/seats/summaryTitle';
import { pricesForZone } from 'services/Pricer';
import { toCurrency } from 'services/Pricer';

import { IconRemove } from 'components/Icons';
import Price from 'components/Price';
import features from '../lib/common/features';

class LineItem extends Component {
  constructor(props) {
    super(props);

    this.handlePriceTypeChange = this.handlePriceTypeChange.bind(this);
  }

  handlePriceTypeChange(event) {
    const prices = pricesForZone(
      this.props.prices,
      this.props.lineItem.seatData.zone_no
    );

    const priceData = find(prices, function(item) {
      return parseInt(item.price_type, 10) === parseInt(event.target.value, 10);
    });

    this.props.onChangeUpdatePrice(this.props.lineItem, priceData);
  }

  render() {
    const item = this.props.lineItem;
    const prices = pricesForZone(this.props.prices, item.seatData.zone_no);

    const showMultiplePriceTypes =
      !this.props.isUpgrade &&
      !this.props.isExchange &&
      this.props.onChangeUpdatePrice &&
      prices.length > 1;

    return (
      <div
        className={classnames({
          'syos-lineitem': true,
          'syos-lineitem--multiple': showMultiplePriceTypes
        })}
      >
        <span className="syos-lineitem__details">
          {!item.isLocked && (
            <button
              className="syos-lineitem__remove"
              type="button"
              onClick={this.props.onClickRemoval}
              aria-label="Remove this seat"
            >
              <IconRemove />
            </button>
          )}
          {item.isLocked ? (
            <span className="syos-lineitem__title">
              {summaryTitle(item.seatData)}
            </span>
          ) : (
            <button
              className="syos-lineitem__title u-syos-button-reset"
              onClick={this.props.onClickReselect}
              type="button"
            >
              {summaryTitle(item.seatData)}
              {parseInt(this.props.podTicketsAmount) > 0 && (
                <span> (x{this.props.podTicketsAmount})</span>
              )}
            </button>
          )}
        </span>
        <div className="syos-lineitem__price">
          {showMultiplePriceTypes ? (
            <div className="syos-price-switch">
              <select
                className="syos-price-switch__select"
                onChange={this.handlePriceTypeChange}
                value={item.priceData.price_type}
              >
                <optgroup label="Change your price">
                  {prices.map(function(price) {
                    let newPrice = price.price_with_fee
                      ? price.price_with_fee
                      : price.price;
                    return (
                      <option key={price.price_type} value={price.price_type}>
                        {`${price.price_type_desc} ${toCurrency(newPrice)}`}
                      </option>
                    );
                  })}
                </optgroup>
              </select>
              {this.props.lineItem.priceData.fee_amount ? (
                <div
                  className="syos-price__breakdown"
                  dangerouslySetInnerHTML={{
                    __html: features
                      .getOption('priceFees', 'label')
                      .replace(
                        '{{ fees }}',
                        toCurrency(this.props.lineItem.priceData.fee_amount)
                      )
                      .replace(
                        '{{ price }}',
                        toCurrency(this.props.lineItem.priceData.price)
                      )
                  }}
                />
              ) : null}
            </div>
          ) : (
            <Price
              priceData={item.priceData}
              showDescription={prices.length > 1}
            />
          )}
        </div>
      </div>
    );
  }
}

LineItem.propTypes = {
  lineItem: PropTypes.object,
  isExchange: PropTypes.bool,
  isUpgrade: PropTypes.bool,
  prices: PropTypes.array,
  onClickRemoval: PropTypes.func,
  onClickReselect: PropTypes.func,
  onChangeUpdatePrice: PropTypes.func,
  podTicketsAmount: PropTypes.number
};

export default LineItem;



// WEBPACK FOOTER //
// ./src/javascripts/app/components/LineItem.js